// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jNKu-","inner":"styles_inner__2Vids","right":"styles_right__1YWLA","close":"styles_close__3wpLJ","footer":"styles_footer__1Vqgk"};